import logo from './logo.svg';
import './App.css';
import { useState } from "react";
import Home from './components/home';
import Another from './components/another';

import {Animated} from 'react-animated-css';
import { Routes,Route,Link} from "react-router-dom";

function App() {

  return (
    <Routes>
    <Route path="/another" element={<Another/>}>   </Route>
    <Route path="/" element={<Home/>}>  
    </Route>
  </Routes>
)
};

export default App;